<dialog class="modal" #dialog>
  <div class="modal-box w-fit">
    <canvas #canvas style="width: 244px; height: 244px"></canvas>
    <div class="flex justify-center">
      <button class="btn btn-ghost btn-sm" (click)="download()">
        <market-icon iconName="download"></market-icon>
      </button>
    </div>
  </div>
  <form method="dialog" class="modal-backdrop">
    <button>close</button>
  </form>
</dialog>
